export const Payable = {
  advancePayable: "advance",
  netPayable: "net",
}

export const PayableReceivableDate = "12-12-2024"
